export const styles = {
  root: {
    height: "calc(100vh - 106px)",
    display: "flex",
    flexFlow: "column",
  },
  customRoot: {
    height: "calc(100vh - 156px)",
  },
  headerBar: {
    width: "100%",
    paddingRight: 20,
    marginTop: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    borderTop: "1px solid #dadada",
  },
  filterIcon: {
    width: 24,
    height: 24,
    fill: "none",
  },
  iconWrapper: {
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  activeWrapper: {
    background: "linear-gradient(0deg, rgba(38, 187, 237, 0.1), rgba(38, 187, 237, 0.1)), #FFFFFF",
  },
  contentBox: {
    padding: 20,
    height: "100%",
    display: "flex",
    flexFlow: "column",
  },
  tableWrapper: {
    marginTop: 12,
    maxHeight: "79vh",
    overflowY: "auto",
  },
  tableHeader: {
    fontFamily: "Open Sans",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
    color: "#333333",
    position: "sticky",
    top: -1,
    background: "white",
    zIndex: 1,
  },
  tableCell: {
    padding: "16px 32px 16px 16px",
    verticalAlign: "middle",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontSize: 14,
    lineHeight: "20px",
    color: "#333333",
    fontWeight: 400,
  },
  extraNumber: {
    fontWeight: 600,
    color: "#4F6FAE",
  },
  bold: {
    fontWeight: 600,
  },
};
